import bind from 'bind-decorator';
import * as React from 'react';

const styles = require('@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/tabsPanel/scrollZone/ScrollZone.less');

export enum ScrollTypes
{
    Vertical = 'vertical',
    Horizontal = 'horizontal'
}

export type ScrollHandler = () => void;

enum ScrollDirection
{
    Top = 'top',
    Bottom = 'bottom',
    Left = 'left',
    Right = 'right'
}

enum Actions
{
    ScrollLeft = 'scrollLeft',
    ScrollRight = 'scrollRight',
    ScrollTop = 'scrollTop',
    ScrollBottom = 'scrollBottom',
    StopScrolling = 'stopScrolling'
}

const scrollStep = 10;
const scrollIndicatorSize = 10;

export interface IScrollZoneProps
{
    type:ScrollTypes,
    onScroll?:ScrollHandler,
    active?:boolean,
}

export interface IScrollZoneState
{
    isActive:boolean
}

export interface ScrollContainerOptions
{
    width:number,
    scrollLeft:number,
    scrollWidth:number
}

export class ScrollZone extends React.Component<IScrollZoneProps, IScrollZoneState>
{
    private _contentContainerRef:HTMLElement;
    private _scrollingInterval = null;

    state = {
        isActive: true
    };

    private _actionHandler(action):void
    {
        switch( action )
        {
            case Actions.ScrollRight:
                this._scrollTo(ScrollDirection.Right);
                break;

            case Actions.ScrollLeft:
                this._scrollTo(ScrollDirection.Left);
                break;

            case Actions.ScrollTop:
                this._scrollTo(ScrollDirection.Top);
                break;

            case Actions.ScrollBottom:
                this._scrollTo(ScrollDirection.Bottom);
                break;

            case Actions.StopScrolling:
                this._stopScrolling();
                break;
        }
    }

    private _stopScrolling():void
    {
        clearInterval(this._scrollingInterval);
        this._scrollingInterval = null;
    }

    private _scrollTo(direction:ScrollDirection):void
    {
        this._stopScrolling();
        this._scrollingInterval = setInterval(() =>
        {
            const contentContainer = this._contentContainerRef;
            const params = {left: 0, top: 0};
            const currentParams = {left: contentContainer.scrollLeft, top: contentContainer.scrollTop};
            switch( direction )
            {
                case ScrollDirection.Left:
                    params.left = currentParams.left - scrollStep;
                    break;

                case ScrollDirection.Right:
                    params.left = currentParams.left + scrollStep;
                    break;

                case ScrollDirection.Top:
                    params.top = currentParams.top - scrollStep;
                    break;

                case ScrollDirection.Bottom:
                    params.top = currentParams.top + scrollStep;
                    break;

                default:
                    return;
            }
            contentContainer.scrollTo(params);
        }, 10);
    }

    public componentWillMount():void
    {
        const {active} = this.props;

        if( typeof active === 'boolean' )
            this.setState({isActive: active});

        window.addEventListener('mousemove', this._onMouseMove);
    }

    public componentWillUnmount():void
    {
        window.removeEventListener('mousemove', this._onMouseMove);
    }

    public componentWillReceiveProps(newProps:IScrollZoneProps):void
    {
        const {active} = this.props;
        const newActive = newProps.active;

        if( active !== newActive && typeof newActive === 'boolean' )
        {
            this.setState({isActive: newActive});
            this._stopScrolling();
        }
    }

    private _scrollHorizontally(cursorPositionX:number):void
    {
        const contentContainer = this._contentContainerRef;
        const containerOffset = contentContainer.getBoundingClientRect();
        const containerLeft = containerOffset.left;
        const containerRight = containerLeft + containerOffset.width;

        if( cursorPositionX < (containerLeft + scrollIndicatorSize) )
            this._actionHandler(Actions.ScrollLeft);
        else if( cursorPositionX > (containerRight - scrollIndicatorSize) )
            this._actionHandler(Actions.ScrollRight);
        else
            this._actionHandler(Actions.StopScrolling);
    }

    private _scrollVertically(cursorPositionY:number):void
    {
        const contentContainer = this._contentContainerRef;
        const containerOffset = contentContainer.getBoundingClientRect();
        const containerTop = containerOffset.top;
        const containerRight = containerTop + containerOffset.height;

        if( cursorPositionY < (containerTop + scrollIndicatorSize) )
            this._actionHandler(Actions.ScrollTop);
        else if( cursorPositionY > (containerRight - scrollIndicatorSize) )
            this._actionHandler(Actions.ScrollBottom);
        else
            this._actionHandler(Actions.StopScrolling);
    }

    @bind
    private _onMouseMove(e):void
    {
        const {isActive} = this.state;
        if( !isActive )
            return;

        const {type} = this.props;

        if( type === ScrollTypes.Horizontal )
            this._scrollHorizontally(e.clientX);

        if( type === ScrollTypes.Vertical )
            this._scrollVertically(e.clientY);
    }

    public getScrollContainerOptions():ScrollContainerOptions
    {
        const contentContainer = this._contentContainerRef;

        return {
            width: contentContainer.clientWidth,
            scrollLeft: contentContainer.scrollLeft,
            scrollWidth: contentContainer.scrollWidth
        };
    }

    public scrollTo(options:ScrollToOptions):void
    {
        this._contentContainerRef.scrollTo(options);
    }

    public render():JSX.Element
    {
        const {
            children, onScroll = () =>
            {
            }
        } = this.props;

        return (
            <div className={styles.base}>
                <div
                    className={styles.contentContainer}
                    onScroll={() => onScroll()}
                    ref={(ref) => (this._contentContainerRef = ref)}
                >{children}</div>
            </div>
        );
    }
}
